var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.621,
    height: 19.01,
    viewBox: "0 0 20.621 19.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_24",
    "data-name": "Union 24",
    d: "M12536.634,11260.9h-.775a2.862,2.862,0,0,1-2.857-2.86v-9.184a2.861,2.861,0,0,1,2.857-2.857h14.9a2.863,2.863,0,0,1,2.861,2.86v5.693c0,.1,0,.189-.007.277v3.21a2.862,2.862,0,0,1-2.857,2.86h-7.99l-6.134,4.108Zm2.436-4.937h8.853v-1.437h-8.853Zm0-3.479h8.853v-1.433h-8.853Z",
    transform: "translate(-12533.001 -11246.001)",
    fill: "#8a8989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6dccddedc2fd46f687e094ffb1c30d6e.svg";
export { ForwardRef as ReactComponent };